import {
  PACKAGE_BOUGHT,
  PACKAGE_PROCESSED,
  PACKAGE_IN_TRANSIT,
  PACKAGE_ON_DELIVERY,
  PACKAGE_RECEIVED,
  PACKAGE_STORED,
  PACKAGE_DELIVERED
} from './packageStatus'

export const PACKAGE_TITLES = {
  [PACKAGE_BOUGHT]: 'Estamos preparando tu pedido',
  [PACKAGE_PROCESSED]: 'Tu pedido ya está armado',
  [PACKAGE_IN_TRANSIT]: 'Tu pedido ya está en manos del transportista',
  [PACKAGE_ON_DELIVERY]: 'Tu pedido va en camino',
  [PACKAGE_RECEIVED]: 'Ya puedes retirar tu pedido',
  [PACKAGE_STORED]: 'Ya puedes retirar tu pedido',
  [PACKAGE_DELIVERED]: 'Tu pedido ya fue entregado'
}

export const PACKAGE_DESCRIPTIONS = {
  [PACKAGE_BOUGHT]: 'Te confirmaremos una vez tu pedido este listo',
  [PACKAGE_PROCESSED]: 'Te avisaremos cuando salga del centro de distribución',
  [PACKAGE_IN_TRANSIT]: 'Pronto saldrá a reparto y te avisaremos cuando esté en camino',
  [PACKAGE_ON_DELIVERY]: '',
  [PACKAGE_RECEIVED]: '',
  [PACKAGE_STORED]: '',
  [PACKAGE_DELIVERED]: '¡Esperamos que lo disfrutes!'
}

export const STATUS_STEP_TITLES = {
  [PACKAGE_BOUGHT]: 1,
  [PACKAGE_PROCESSED]: 1,
  [PACKAGE_IN_TRANSIT]: 1,
  [PACKAGE_ON_DELIVERY]: 2,
  [PACKAGE_RECEIVED]: 3,
  [PACKAGE_STORED]: 3,
  [PACKAGE_DELIVERED]: 4
}
